import React from "react";
import { Box, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

// Convert Jalali to approximate Gregorian
const jalaliToGregorian = (jy) => jy + 622;

function YearsDrop({ year, setYear }) {
  // Convert year object {year: '1404'} to JS Date
  const selectedDate = year?.year
    ? new Date(jalaliToGregorian(parseInt(year.year, 10)), 1, 1)
    : null;

  return (
    <Box sx={{ flex: 1, minWidth: 160 }}>
      <DatePicker
        views={["year"]}
        label="انتخاب سال"
        value={selectedDate}
        onChange={(newValue) => {
          if (!newValue) return;

          const dateObj =
            newValue instanceof Date ? newValue : new Date(newValue);
          if (!isNaN(dateObj.getFullYear())) {
            const jy = dateObj.getFullYear() - 622;
            setYear({ year: jy.toString() }); // Set as object
          }
        }}
        minDate={new Date(jalaliToGregorian(1278), 0, 0)}
        maxDate={new Date(jalaliToGregorian(1478), 11, 31)}
        renderInput={(params) => (
          <TextField {...params} size="small" helperText={null} fullWidth />
        )}
      />
    </Box>
  );
}

export default YearsDrop;
